<template>
	<div class="part palavra">
		<div v-html="part.PartEnunciado" class="enunciado">
		</div>
		<div v-html="part.PartConteudo" class="conteudo">
		</div>
		<options-box 
		ref="optionsbox"
		:large="true"
		:part="part"></options-box>
	</div>
</template>

<style scoped>
.part.palavra div.conteudo {
	max-width: 465px;
}
</style>

<script>
import RelacioneBox from '../RelacioneAnswerBox'
import bus from '@/bus/event-bus.js'

export default {
	props: ['part', 'locked'],

	data() {
		return {
			partId: null,
			opcoes: []
		}
	},

	watch: {
		part() {
			if(this.part.PartId !== this.partId) {
				
			}
		}
	},

	mounted() {
	},

	methods: {

		
	},

	components: {
		'options-box': RelacioneBox
	}
}
</script>


// WEBPACK FOOTER //
// src/components/perguntas/relacione/PerguntaRelacione.vue